import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MastermodulePage } from './mastermodule.page';

const routes: Routes = [
  {
    path: '',
    component: MastermodulePage,
  },
  {
    path: 'mod0104',
    loadChildren: () =>
      import('./mod0104/mod0104.module').then((m) => m.Mod0104PageModule),
  },
  {
    path: 'mod0105',
    loadChildren: () =>
      import('./mod0105/mod0105.module').then((m) => m.Mod0105PageModule),
  },
  {
    path: 'mod0107',
    loadChildren: () =>
      import('./mod0107/mod0107.module').then((m) => m.Mod0107PageModule),
  },
  {
    path: 'mod0108',
    loadChildren: () =>
      import('./mod0108/mod0108.module').then((m) => m.Mod0108PageModule),
  },
  {
    path: 'mod0109',
    loadChildren: () =>
      import('./mod0109/mod0109.module').then((m) => m.Mod0109PageModule),
  },
  {
    path: 'mod0110',
    loadChildren: () =>
      import('./mod0110/mod0110.module').then((m) => m.Mod0110PageModule),
  },
  {
    path: 'mod0111',
    loadChildren: () =>
      import('./mod0111/mod0111.module').then((m) => m.Mod0111PageModule),
  },
  {
    path: 'mod0112',
    loadChildren: () =>
      import('./mod0112/mod0112.module').then((m) => m.Mod0112PageModule),
  },
  {
    path: 'mod0113',
    loadChildren: () =>
      import('./mod0113/mod0113.module').then((m) => m.Mod0113PageModule),
  },
  {
    path: 'mod0114',
    loadChildren: () =>
      import('./mod0114/mod0114.module').then((m) => m.Mod0114PageModule),
  },
  {
    path: 'mod0117',
    loadChildren: () =>
      import('./mod0117/mod0117.module').then((m) => m.Mod0117PageModule),
  },
  {
    path: 'mod0118',
    loadChildren: () =>
      import('./mod0118/mod0118.module').then((m) => m.Mod0118PageModule),
  },
  {
    path: 'mod0121',
    loadChildren: () =>
      import('./mod0121/mod0121.module').then((m) => m.Mod0121PageModule),
  },
  {
    path: 'mod0122',
    loadChildren: () =>
      import('./mod0122/mod0122.module').then((m) => m.Mod0122PageModule),
  },
  {
    path: 'mod0124',
    loadChildren: () =>
      import('./mod0124/mod0124.module').then((m) => m.Mod0124PageModule),
  },
  {
    path: 'mod0126',
    loadChildren: () =>
      import('./mod0126/mod0126.module').then((m) => m.Mod0126PageModule),
  },
  {
    path: 'mod0128',
    loadChildren: () =>
      import('./mod0128/mod0128.module').then((m) => m.Mod0128PageModule),
  },
  {
    path: 'mod0155',
    loadChildren: () =>
      import('./mod0155/mod0155.module').then((m) => m.Mod0155PageModule),
  },
  {
    path: 'mod0158',
    loadChildren: () =>
      import('./mod0158/mod0158.module').then((m) => m.Mod0158PageModule),
  },
  {
    path: 'mod0164',
    loadChildren: () =>
      import('./mod0164/mod0164.module').then((m) => m.Mod0164PageModule),
  },
  {
    path: 'mod0165',
    loadChildren: () =>
      import('./mod0165/mod0165.module').then((m) => m.Mod0165PageModule),
  },
  {
    path: 'mod0167',
    loadChildren: () =>
      import('./mod0167/mod0167.module').then((m) => m.Mod0167PageModule),
  },
  {
    path: 'mod0168',
    loadChildren: () =>
      import('./mod0168/mod0168.module').then((m) => m.Mod0168PageModule),
  },

  {
    path: 'mod0168',
    loadChildren: () =>
      import('./mod0168/mod0168.module').then((m) => m.Mod0168PageModule),
  },

  {
    path: 'mod0171',
    loadChildren: () =>
      import('./mod0171/mod0171.module').then((m) => m.Mod0171PageModule),
  },
  {
    path: 'mod0120',
    loadChildren: () =>
      import('./mod0120/mod0120.module').then((m) => m.Mod0120PageModule),
  },
  {
    path: 'mod0203',
    loadChildren: () =>
      import('./mod0203/mod0203.module').then((m) => m.Mod0203PageModule),
  },
  {
    path: 'mod0204',
    loadChildren: () =>
      import('./mod0204/mod0204.module').then((m) => m.Mod0204PageModule),
  },
  {
    path: 'mod0205',
    loadChildren: () =>
      import('./mod0205/mod0205.module').then((m) => m.Mod0205PageModule),
  },
  {
    path: 'mod0206',
    loadChildren: () =>
      import('./mod0206/mod0206.module').then((m) => m.Mod0206PageModule),
  },
  {
    path: 'mod0207',
    loadChildren: () =>
      import('./mod0207/mod0207.module').then((m) => m.Mod0207PageModule),
  },
  {
    path: 'mod0208',
    loadChildren: () =>
      import('./mod0208/mod0208.module').then((m) => m.Mod0208PageModule),
  },
  {
    path: 'mod0209',
    loadChildren: () =>
      import('./mod0209/mod0209.module').then((m) => m.Mod0209PageModule),
  },
  {
    path: 'mod0211',
    loadChildren: () =>
      import('./mod0211/mod0211.module').then((m) => m.Mod0211PageModule),
  },
  {
    path: 'mod0212',
    loadChildren: () =>
      import('./mod0212/mod0212.module').then((m) => m.Mod0212PageModule),
  },
  {
    path: 'mod0213',
    loadChildren: () =>
      import('./mod0213/mod0213.module').then((m) => m.Mod0213PageModule),
  },
  {
    path: 'mod0214',
    loadChildren: () =>import('./mod0214/mod0214.module').then((m) => m.Mod0214PageModule),
  },
  {
    path: 'mod0216',
    loadChildren: () => import('./mod0216/mod0216.module').then((m) => m.Mod0216PageModule),
  },
  {
    path: 'mod0217',
    loadChildren: () => import('./mod0217/mod0217.module').then( m => m.Mod0217PageModule)
  },
  {
    path: 'mod0218',
    loadChildren: () => import('./mod0218/mod0218.module').then( m => m.Mod0218PageModule)
  },
  {
    path: 'mod0219',
    loadChildren: () => import('./mod0219/mod0219.module').then( m => m.Mod0219PageModule)
  },
  {
    path: 'mod0220',
    loadChildren: () => import('./mod0220/mod0220.module').then( m => m.Mod0220PageModule)
  },
  {
    path: 'mod0221',
    loadChildren: () => import('./mod0221/mod0221.module').then( m => m.Mod0221PageModule)
  },
  {
    path: 'mod0222',
    loadChildren: () => import('./mod0222/mod0222.module').then( m => m.Mod0222PageModule)
  },
  {
    path: 'mod0223',
    loadChildren: () => import('./mod0223/mod0223.module').then( m => m.Mod0223PageModule)
  },
  {
    path: 'mod0224',
    loadChildren: () => import('./mod0224/mod0224.module').then( m => m.Mod0224PageModule)
  },
  {
    path: 'mod0225',
    loadChildren: () => import('./mod0225/mod0225.module').then( m => m.Mod0225PageModule)
  },
  {
    path: 'mod0226',
    loadChildren: () => import('./mod0226/mod0226.module').then( m => m.Mod0226PageModule)
  },
  {
    path: 'mod0227',
    loadChildren: () => import('./mod0227/mod0227.module').then( m => m.Mod0227PageModule)
  },
  {
    path: 'mod0228',
    loadChildren: () => import('./mod0228/mod0228.module').then( m => m.Mod0228PageModule)
  },
  {
    path: 'mod0229',
    loadChildren: () => import('./mod0229/mod0229.module').then( m => m.Mod0229PageModule)
  },
  {
    path: 'mod0230',
    loadChildren: () => import('./mod0230/mod0230.module').then( m => m.Mod0230PageModule)
  },
  {
    path: 'mod0231',
    loadChildren: () => import('./mod0231/mod0231.module').then( m => m.Mod0231PageModule)
  },
  {
    path: 'mod0232',
    loadChildren: () => import('./mod0232/mod0232.module').then( m => m.Mod0232PageModule)
  },
  {
    path: 'mod0233',
    loadChildren: () => import('./mod0233/mod0233.module').then( m => m.Mod0233PageModule)
  },
  {
    path: 'mod0234',
    loadChildren: () => import('./mod0234/mod0234.module').then( m => m.Mod0234PageModule)
  },
  {
    path: 'mod0235',
    loadChildren: () => import('./mod0235/mod0235.module').then( m => m.Mod0235PageModule)
  },
  {
    path: 'mod0236',
    loadChildren: () => import('./mod0236/mod0236.module').then( m => m.Mod0236PageModule)
  },
  {
    path: 'mod0237',
    loadChildren: () => import('./mod0237/mod0237.module').then( m => m.Mod0237PageModule)
  },
  {
    path: 'mod0238',
    loadChildren: () => import('./mod0238/mod0238.module').then( m => m.Mod0238PageModule)
  },
  {
    path: 'mod0239',
    loadChildren: () => import('./mod0239/mod0239.module').then( m => m.Mod0239PageModule)
  },
  {
    path: 'mod0240',
    loadChildren: () => import('./mod0240/mod0240.module').then( m => m.Mod0240PageModule)
  },
  {
    path: 'mod0241',
    loadChildren: () => import('./mod0241/mod0241.module').then( m => m.Mod0241PageModule)
  },
  {
    path: 'mod0242',
    loadChildren: () => import('./mod0242/mod0242.module').then( m => m.Mod0242PageModule)
  },
  {
    path: 'mod0243',
    loadChildren: () => import('./mod0243/mod0243.module').then( m => m.Mod0243PageModule)
  },
  {
    path: 'mod0244',
    loadChildren: () => import('./mod0244/mod0244.module').then( m => m.Mod0244PageModule)
  },
  {
    path: 'mod0245',
    loadChildren: () => import('./mod0245/mod0245.module').then( m => m.Mod0245PageModule)
  },
  {
    path: 'mod0246',
    loadChildren: () => import('./mod0246/mod0246.module').then( m => m.Mod0246PageModule)
  },
  {
    path: 'mod0247',
    loadChildren: () => import('./mod0247/mod0247.module').then( m => m.Mod0247PageModule)
  },
  {
    path: 'mod0248',
    loadChildren: () => import('./mod0248/mod0248.module').then( m => m.Mod0248PageModule)
  },
  {
    path: 'mod0249',
    loadChildren: () => import('./mod0249/mod0249.module').then( m => m.Mod0249PageModule)
  },
  {
    path: 'mod0250',
    loadChildren: () => import('./mod0250/mod0250.module').then( m => m.Mod0250PageModule)
  },
  {
    path: 'mod0251',
    loadChildren: () => import('./mod0251/mod0251.module').then( m => m.Mod0251PageModule)
  },
  {
    path: 'mod0252',
    loadChildren: () => import('./mod0252/mod0252.module').then( m => m.Mod0252PageModule)
  },
  {
    path: 'mod0253',
    loadChildren: () => import('./mod0253/mod0253.module').then( m => m.Mod0253PageModule)
  },
  {
    path: 'mod0254',
    loadChildren: () => import('./mod0254/mod0254.module').then( m => m.Mod0254PageModule)
  },
  {
    path: 'mod0255',
    loadChildren: () => import('./mod0255/mod0255.module').then( m => m.Mod0255PageModule)
  },
  {
    path: 'mod0256',
    loadChildren: () => import('./mod0256/mod0256.module').then( m => m.Mod0256PageModule)
  },
  {
    path: 'mod0257',
    loadChildren: () => import('./mod0257/mod0257.module').then( m => m.Mod0257PageModule)
  },
  {
    path: 'mod0258',
    loadChildren: () => import('./mod0258/mod0258.module').then( m => m.Mod0258PageModule)
  },
  {
    path: 'mod0259',
    loadChildren: () => import('./mod0259/mod0259.module').then( m => m.Mod0259PageModule)
  },
  {
    path: 'mod0260',
    loadChildren: () => import('./mod0260/mod0260.module').then(m => m.Mod0260PageModule)
  },
  {
    path: 'mod0261',
    loadChildren: () => import('./mod0261/mod0261.module').then( m => m.Mod0261PageModule)
  },
  {
    path: 'mod0262',
    loadChildren: () => import('./mod0262/mod0262.module').then( m => m.Mod0262PageModule)
  },
  {
    path: 'mod0263',
    loadChildren: () => import('./mod0263/mod0263.module').then( m => m.Mod0263PageModule)
  },
  {
    path: 'mod0264',
    loadChildren: () => import('./mod0264/mod0264.module').then( m => m.Mod0264PageModule)
  },
  {
    path: 'mod0265',
    loadChildren: () => import('./mod0265/mod0265.module').then( m => m.Mod0265PageModule)
  },
  {
    path: 'mod0266',
    loadChildren: () => import('./mod0266/mod0266.module').then( m => m.Mod0266PageModule)
  },
  {
    path: 'mod0267',
    loadChildren: () => import('./mod0267/mod0267.module').then( m => m.Mod0267PageModule)
  },
  {
    path: 'mod0268',
    loadChildren: () => import('./mod0268/mod0268.module').then( m => m.Mod0268PageModule)
  },
  {
    path: 'mod0269',
    loadChildren: () => import('./mod0269/mod0269.module').then( m => m.Mod0269PageModule)
  },
  {
    path: 'mod0270',
    loadChildren: () => import('./mod0270/mod0270.module').then( m => m.Mod0270PageModule)
  },
  {
    path: 'mod0271',
    loadChildren: () => import('./mod0271/mod0271.module').then( m => m.Mod0271PageModule)
  },
  {
    path: 'mod0272',
    loadChildren: () => import('./mod0272/mod0272.module').then( m => m.Mod0272PageModule)
  },
  {
    path: 'mod0273',
    loadChildren: () => import('./mod0273/mod0273.module').then( m => m.Mod0273PageModule)
  },
  {
    path: 'mod0274',
    loadChildren: () => import('./mod0274/mod0274.module').then( m => m.Mod0274PageModule)
  },
  {
    path: 'mod0275',
    loadChildren: () => import('./mod0275/mod0275.module').then( m => m.Mod0275PageModule)
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MastermodulePageRoutingModule {}
